import { Concept } from '@/constants/scenarios';
import { TransferPairResponse } from '@/types/transfer-pair';

function toNum(v: unknown): number {
  return typeof v === 'number' && Number.isFinite(v) ? v : 0;
}

export function nonRecoverableTaxes(pair: TransferPairResponse): number {
  // Excel "Other Non Recuperable Taxes" = State + Municipal + Additional + Earnings Retention + Non Recoverable VAT
  return (
    toNum(pair.localTaxState) +
    toNum(pair.localTaxMunicipal) +
    toNum(pair.localTaxAdditional) +
    toNum(pair.earningsRetention) +
    toNum(pair.nonRecoverableVat)
  );
}

export function pickByConcept<T>(
  concept: Concept,
  values: { infrastructure: T; licenses: T; service: T; support: T },
): T {
  return values[concept];
}
